export enum AdjustmentTypeEnum {
  REPLACEMENT = 'replacement',
  NO_CHARGE = 'noCharge',
  NO_FREIGHT = 'noFreight',
}
